import {APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {DelonModule} from './delon.module';
import {CoreModule} from './core/core.module';
import {AppComponent} from './app.component';
import {RoutesModule} from './routes/routes.module';
import {LayoutModule} from './layout/layout.module';
import {StartupService} from '@core/startup/startup.service';
import {DefaultInterceptor} from '@core/net/default.interceptor';
import {JWTInterceptor} from '@delon/auth';
import {AppSharedModule} from "./app-shared/app-shared.module";
// angular i18n
import {registerLocaleData} from '@angular/common';
import localeZh from '@angular/common/locales/zh';
// i18n
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {ALAIN_I18N_TOKEN} from '@delon/theme';
import {I18NService} from '@core/i18n/i18n.service';
// @delon/form: JSON Schema form
import {JsonSchemaModule} from '@shared/json-schema/json-schema.module';
import {SoaMaterialComponent} from "./routes/jy-srm/soa/soa-material/soa-material.component";

registerLocaleData(localeZh);

// 加载i18n语言文件
export function I18nHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, `assets/tmp/i18n/`, '.json');
}

export function StartupServiceFactory(startupService: StartupService): Function {
  return () => startupService.loadSystemInfo();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    DelonModule.forRoot(),
    CoreModule,
    AppSharedModule,
    LayoutModule,
    RoutesModule,
    // i18n
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: I18nHttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    // JSON-Schema form
    JsonSchemaModule,

  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'zh-Hans'},
    {provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: DefaultInterceptor, multi: true},
    {provide: ALAIN_I18N_TOKEN, useClass: I18NService, multi: false},
    StartupService,
    {
      provide: APP_INITIALIZER,
      useFactory: StartupServiceFactory,
      deps: [StartupService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
